import INFTCollections from '../../models/INFTCollections'
import CryptoDappersCard from '../../nftFormats/CryptoDapper/Card/CryptoDappersCard'
import CryptoDappersDetail from '../../nftFormats/CryptoDapper/Detail/CryptoDappersDetail'
import CryptoDappersActivtyDetail from '../../nftFormats/CryptoDapper/Activity/CryptoDappersActivtyDetail'
import CryptoDappersLogo from '../../../../assets/nft-logo/CryptoDappers.jpg'

export const CryptoDappersData: INFTCollections = {
  id: 'CryptoDappers',
  tokenAddress: '0x7d03a94e2ee105f130e70b9eb34599f22e4ef6af',
  name: 'Crypto Dappers',
  cardFormat: CryptoDappersCard,
  detailFormat: CryptoDappersDetail,
  activityFormat: CryptoDappersActivtyDetail,
  category: 2,
  creatorAddress: '0xA4daEcDcEc5ecc5DA646B3f8dd161e0dd2b992bB',
  logo: CryptoDappersLogo,
  website: 'https://www.crypto-dappers.art/',
  twitter: 'CryptoDappers',
  discord: 'https://discord.com/invite/RB4gP2xvMH',
  telegram: 'https://t.me/joinchat/IbiTHrlmt102NTQx'
}

export const CryptoDappersCategoryData = {
  [CryptoDappersData.tokenAddress.toLowerCase()]: CryptoDappersData.category
}
